import { BASE_URL, CONTEXT_PATH } from "../constants";
import {
    getRefreshToken,
    saveNewAccessToken,
    deleteCookie,
    getAccessToken,
} from "../utils/customMethods";

const axios = require("axios");
let isAlreadyFetchingAccessToken = false;
let subscribers = [];
const config = {
    headers: { Authorization: "Basic " + btoa("my-trusted-client:secret") },
    responseType: "json",
};

export const getAxiosInstance = () => {
    const instance = axios.create({
        baseURL: BASE_URL + CONTEXT_PATH,
    });
    instance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if ((((error||{}).response||{}).status||'') === 401) {
                return resetTokenAndReattemptRequest(error);
            } else {
                return error.response||{};
            }
        }
    );

    return instance;
};

const resetTokenAndReattemptRequest = async error => {
    try {
        const { response: errorResponse } = error;
        const resetToken = getRefreshToken(); // Your own mechanism to get the refresh token to refresh the JWT token
        if (!resetToken) {
            // We can't refresh, throw the error anyway
            window.location.href = "/";
        }
        /* Proceed to the token refresh procedure
    We create a new Promise that will retry the request,
    clone all the request configuration from the failed
    request in the error object. */
        const retryOriginalRequest = new Promise(resolve => {
            /* We need to add the request retry to the queue
    since there another request that already attempt to
    refresh the token */
            addSubscriber(() => {
                errorResponse.config.url =
                    errorResponse.config.url + getAccessToken();
                resolve(axios(errorResponse.config));
            });
        });
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            const response = await axios.post(
                `${BASE_URL}oauth/token?grant_type=refresh_token&refresh_token=${resetToken}`,
                "",
                config
            );
            if (!response.data) {
                deleteCookie("user_token");
                deleteCookie("access_token");
                deleteCookie("refresh_token");
                window.location.href = "/";
            } else {
                const newToken = response.data.token;
                saveNewAccessToken(response.data);
                //TokenUtils.saveRefreshToken(newToken); // save the newly refreshed token for other requests to use
                isAlreadyFetchingAccessToken = false;
                onAccessTokenFetched(newToken);
            }
        }
        return retryOriginalRequest;
    } catch (err) {
        if (err.response.status == 401) {
            deleteCookie("user_token");
            deleteCookie("access_token");
            deleteCookie("refresh_token");
            window.location.href = "/";
        } else {
            console.log(err);
        }
    }
};
const onAccessTokenFetched = access_token => {
    // When the refresh is successful, we start retrying the requests one by one and empty the queue
    subscribers.forEach(callback => callback(access_token));
    subscribers = [];
};
const addSubscriber = callback => {
    subscribers.push(callback);
};
